import React from "react";
import { Space, Tooltip } from "antd";
import { AntSekelton } from "@Component/Skeleton";
import { useCopy } from "@utils/hooks/useCopy";
import { Button } from "react-bootstrap";

// =========================
// Generic Components
// =========================
export const LabelValue = (props) => {
  const {
    loading,
    label,
    value, // (string || number)
    icon = null,
    direction = "horizontal",
    copyValue = null,
    copyOnValueClick = false,
    buttonIconSize = 18,
    tooltipText = null,
    renderValue = null,
  } = props;

  const { handleCopy, ButtonIcon, copyState } = useCopy({ value: copyValue });

  const showCopyTooltip = copyState !== "idle" && copyOnValueClick;
  const showCopyButton =
    copyValue && !!value && value !== "-" && !copyOnValueClick;

  if (loading) {
    return (
      <SPACE direction={direction}>
        {label && <Label loading />}
        <Value loading />
      </SPACE>
    );
  }

  return (
    <SPACE direction={direction}>
      {label && <Label {...{ label, icon }} />}

      {/* Value */}
      <Space>
        <Tooltip
          open={showCopyTooltip || undefined}
          title={showCopyTooltip ? copyState : tooltipText || undefined}
        >
          <span
            className="text-black fw-bold"
            style={{ cursor: copyOnValueClick ? "pointer" : "default" }}
            onClick={copyOnValueClick ? handleCopy : undefined}
          >
            {!!renderValue ? renderValue(value) : <Value {...{ value }} />}
          </span>
        </Tooltip>

        {showCopyButton && (
          <CopyButton value={copyValue} onClick={handleCopy} {...{ copyState }}>
            {<ButtonIcon iconSize={buttonIconSize} />}
          </CopyButton>
        )}
      </Space>
    </SPACE>
  );
};

// =========================
// HelperComponents
// =========================
const Value = ({
  loading,
  value, // (string || number)
  fallback = false,
}) => {

  if (loading) {
    return (
      <AntSekelton.Node
        size="small"
        style={{ width: "30%", minWidth: "100px", height: "12px" }}
      />
    );
  }

  return value || fallback;
};
const Label = ({ loading, label, icon = null }) => {
  if (loading) {
    return (
      <AntSekelton.Node
        size="small"
        style={{ width: "20%", minWidth: "50px", height: "15px" }}
      />
    );
  }

  return (
    <Space direction="horizontal" gap={2}>
      {icon}
      <span className="mb-0 text-md text-secondary">{label}</span>
    </Space>
  );
};
const SPACE = ({ children, direction = "horizontal" }) => (
  <Space direction={direction} gap={2}>
    {children}
  </Space>
);
const CopyButton = ({ value, copyState, ...props }) => (
  <Button
    {...props}
    variant="secondary"
    className={`btn-outline no-print btn-xs btn-secondary btn-icon ${copyState === "copying" ? "disabled" : ""
      }`}
    disabled={copyState === "copying"}
  />
);

LabelValue.Value = Value;
